import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

import { Tooltip, tooltipClasses } from "scmp-app/components/common/tooltip";

import InfoIcon from "./icon-info.svg";

export const Container = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;

  padding-block: 6px;
  padding-inline: 8px;

  text-align: start;

  border: 1px solid #ffffff;
  border-radius: 4px;

  background: #f8f8f8;

  cursor: pointer;
`;

export const GoogleNewsLink = styled.a`
  display: flex;
  gap: 6px;
  align-items: center;

  color: inherit;
  text-decoration: none;
`;

export const TextContent = styled.span`
  color: #333333;
  font-size: 11px;
  font-family: Roboto;
  line-height: normal;
  white-space: nowrap;
`;

export const ImageGoogle = styled.img`
  display: block;

  inline-size: 16px;
  block-size: 16px;
`;

export const InfoIconButton = styled.button`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;

  padding: 0;

  border: none;

  background: none;

  cursor: pointer;
`;

export const StyledInfoIcon = styled(InfoIcon)`
  display: block;

  inline-size: 14px;
  block-size: 14px;
`;

export const StyledTooltip = styled(Tooltip)`
  & .${tooltipClasses.tooltip} {
    inline-size: 263px;
    padding: 12px;

    font-weight: 400;

    border-radius: 4px;

    background-color: #001246;
  }

  & .${tooltipClasses.arrow} {
    inline-size: 14px;
    block-size: 8px;

    color: #001246;
  }
`;

export const ToolTipMessage = styled.div``;

export const TooltipText = styled.p`
  block-size: 54px;
  margin: 0;

  color: #ffffff;
  font-size: 13px;
  font-family: ${fontRoboto};
  line-height: 1.4;
`;
